import router from './router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken, removeToken, getRuoYiToken } from '@/utils/auth' // get token from cookie
import store from '@/store'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/home', '/login'] // no redirect whitelist

// 检查用户是否有token
const hasValidToken = () => {
  return getToken()
}

// 获取用户信息
const fetchUserInfo = async () => {
  try {
    let user = await store.dispatch('user/getInfo')
    return user
  } catch (error) {
    console.error('获取用户信息失败:', error)
    removeToken()
    return null
  }
}

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()

  const hasToken = hasValidToken()

  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      NProgress.done()
      next({ path: '/' })
    } else {
      if (store.getters.userInfo?.userId) {
        next()
      } else {
        const user = await fetchUserInfo()
        if (user) {
          next()
        } else {
          NProgress.done()
          next(`/login`)
        }
      }
    }
  } else {
    if (whiteList.includes(to.path)) {
      NProgress.done()
      next()
    } else {
      NProgress.done()
      next(`/login`)
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
